import {
  createFiltersAndTermSearchParams,
  Filters
} from "features/resource-discover/utils";

export function linkToTutorLandingPage_deprecated() {
  return `/tutor`;
}

export function linkToResourceDiscover() {
  return `/resource-discover`;
}

export function linkToResourceDiscoverOverview() {
  return `${linkToResourceDiscover()}/overview`;
}

export const linkToResourceDiscoverOverviewWithQueryParams = (
  filters: Filters,
  text?: string
): string => {
  return `${linkToResourceDiscoverOverview()}?${createFiltersAndTermSearchParams(
    filters,
    text
  )}`;
};

export function linkToResourcePreview(resourceId: string = ":resourceId") {
  return `${linkToResourceDiscover()}/preview/resource/${resourceId}`;
}

export { makeLinkToShareResource } from "./share-resource/links";

export const linkToResourceDiscoverFeedback = () => {
  return "https://forms.gle/2E5uTCun354mwLQi9";
};
